import React, { useState } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import InputGroup from "../../../../components/InputGroup";
import Button from "../../../../components/Button";
import ButtonDropdown from "../../../../components/ButtonDropdown";
import moment from "moment";
import Report from "../../../../services/Report";
import FileSaver from "file-saver";
import { Toast } from "../../../../config/Toast";
import { toast } from "react-toastify";

function ReportAction({ onDateChange, onSearch }) {
  const [rangeDate, setRangeDate] = useState([]);
  const [btnExcelLoading, setBtnExcelLoading] = useState(false);
  const notifyFailed = (message) => toast.error(message, Toast);
  const notifySuccess = (message) => toast.success(message, Toast);

  const getWeeksOfMonth = (year, month) => {
    const weeks = [];
    let current = moment(`${year}-${month}-01`).startOf("month");

    while (current.day() !== 4) current.add(1, "day");

    while (current.month() + 1 === month) {
      const start = current.clone();
      const end = current.clone().add(6, "days");

      weeks.push([start.toDate(), end.toDate()]);
      current.add(7, "days");
    }

    return weeks;
  };

  const currentYear = moment().year();
  const currentMonth = moment().month() + 1;
  const weeks = getWeeksOfMonth(currentYear, currentMonth);

  const handleSelectWeek = (index) => {
    const week = weeks[index];
    if (!week) return notifyFailed("Minggu tidak ditemukan.");

    setRangeDate(week);
    onDateChange(week);
    toast.success(`Tanggal terpilih: ${moment(week[0]).format("DD MMM")} - ${moment(week[1]).format("DD MMM")}`, Toast);
  };

  const handleDateChange = (selectedDates, instance) => {
    if (selectedDates.length === 2) {
      const [start, end] = selectedDates;
      const diffDays = (end - start) / (1000 * 60 * 60 * 24) + 1;

      if (diffDays === 7) {
        notifySuccess(`Tanggal terpilih: ${moment(start).format("DD MMM")} - ${moment(end).format("DD MMM")}`, Toast);
        setRangeDate(selectedDates);
        onDateChange(selectedDates);
      } else {
        notifyFailed("Gagal memuat data rekapitulasi Range tanggal harus tepat 7 hari!");
        instance.clear();
      }
    }
  };

  const handleSearchInput = (value) => {
    if (onSearch) onSearch(value);
  };

  const excelHandler = () => {
    if (!rangeDate[0] || !rangeDate[1]) {
      notifyFailed("Tanggal wajib diisi");
      return;
    }

    setBtnExcelLoading(true);
    const payload = {
      start_date: moment(rangeDate[0]).format("YYYY-MM-DD"),
      end_date: moment(rangeDate[1]).format("YYYY-MM-DD"),
    };

    Report.disbursmentWorkerExcelNew(payload)
      .then((res) => {
        const url = `${process.env.REACT_APP_API_DOMAIN}/${res.data.path}`;
        FileSaver.saveAs(url, res.data.path);

        notifySuccess("Success download report disbursment worker");
        setBtnExcelLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setBtnExcelLoading(false);
        notifyFailed("Something went wrong!");
      });
  };

  const dropdownShortcut = [
    { name: "Minggu 1", clickFunction: () => handleSelectWeek(0) },
    { name: "Minggu 2", clickFunction: () => handleSelectWeek(1) },
    { name: "Minggu 3", clickFunction: () => handleSelectWeek(2) },
    { name: "Minggu 4", clickFunction: () => handleSelectWeek(3) },
    { name: "Minggu 5", clickFunction: () => handleSelectWeek(4) },
  ];

  return (
    <div className="d-flex flex-column justify-content-end align-items-end w-100 h-100 gap-3">
      <div className="d-flex justify-content-between align-items-end w-100 gap-3">
        <div className="d-flex align-items-end gap-2 w-100">
          <div className="flex-1">
            <h6 className="fw-bold mb-2">Pilih Rentang Tanggal</h6>
            <Flatpickr
              value={rangeDate}
              options={{ mode: "range", dateFormat: "d-m-Y" }}
              onChange={handleDateChange}
              className="form-control"
              placeholder="Pilih Tanggal Awal dan Akhir"
            />
          </div>
          <ButtonDropdown button="btn-primary" title="Shortcut Date" dropdown={dropdownShortcut} />
          <Button
            button="btn-success btn-md"
            title={btnExcelLoading ? "Exporting..." : "Export to Excel"}
            disabled={btnExcelLoading}
            onClick={excelHandler}
          />
          
          <div className="w-40">
            <InputGroup button="btn-dark" icon="fa fa-search" placeholder="Cari ID/Nama Mitra" searchHandler={handleSearchInput} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportAction;
